// extracted by mini-css-extract-plugin
export default {"statusOverlay":"VideoStreamPlayer_statusOverlay__F74U7","statusText":"VideoStreamPlayer_statusText__nI5fV","video":"VideoStreamPlayer_video__NTPeM"};